<template>
  <div class="rating">
    <ul class="list">
      <li :key="star" v-for="star in maxstars" class="star">
        <font-awesome-icon :class="`fa-${starsize}`" :icon="[star <= stars ? 'fas' : 'far', 'star']"/>
      </li>
    </ul>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas);
library.add(far);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default
{
    components: {
        FontAwesomeIcon
    },
    props: {
        star: {
            type: Number,
            required: true,
        },
        maxstars: {
            type: Number,
            default: 5
        },
        starsize: {
            type: String,
            default: "xs"
        },
    },
    data() {
        return {
            stars: this.star,
        };
    },
}
</script>

<style lang="scss">
$purple_color: #9561e2;
ul.list li,
span {
  display: inline-block;
  margin: 2px;
}
.list {
  margin: 0 0 5px 0;
  padding: 0;
  list-style-type: none;
  span {
    width: 130px;
    margin-left: 5px;
    padding: 5px;
    color: $purple_color;
    border-radius: 2px;
    font-size: 13px;
    text-align: center;
    font-weight: bold;
    transition: 0.2s;
    line-height: 25px;
  }
}
.star {
  cursor: default;
  color: $purple_color
}
.star.active {
  color: $purple_color;
 }
</style>